let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5cMyi")).then(() => parcelRequire('78F7p'));